import React, { useState } from 'react';
// Sayfa içi navigasyon ve URL kontrolü için gerekli hook'lar
import { Link, useLocation, useNavigate } from 'react-router-dom'; 

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation(); 
  const navigate = useNavigate();
  
  const toggleMenu = () => { setIsOpen(!isOpen); };
  
  const closeMenu = () => { setIsOpen(false); };

  // Admin/Patron sayfalarında menüyü gizle
  const adminPaths = [
    '/patron',
    '/admin',
    '/cariler',
    '/odemeler',
    '/tedarikciler',
    '/giderler',
    '/yeni',
    '/musteri',
    '/teknik'
  ];

  // Eğer şu anki adres, yukarıdaki yasaklı listeyle başlıyorsa menüyü gösterme
  const isAdminPage = adminPaths.some(path => location.pathname.startsWith(path));

  if (isAdminPage) {
    return null;
  }

  // Anasayfa butonuna basınca çalışacak özel fonksiyon
  // Bu fonksiyon, HashRouter (#) sorununu çözer ve sayfayı en başa atar
  const handleHomeClick = (e) => {
    e.preventDefault(); // Standart linki durdur
    if (location.pathname === '/') {
        // Zaten anasayfadaysak en tepeye kaydır
        window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
        // Başka sayfadaysak anasayfaya git
        navigate('/');
        // Sayfa yüklendikten sonra tepeye atması için ufak bir gecikme
        setTimeout(() => window.scrollTo(0, 0), 100);
    }
    closeMenu();
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        
        {/* Logo - Tıklayınca En Başa Döner */}
        <a href="/" className="navbar-logo brand-logo" onClick={handleHomeClick}>
          <img 
            src="/logo.png" 
            alt="Aras Asaf İnşaat Logo" 
            style={{ width: '40px', height: '40px', objectFit: 'contain' }}
          />
          Aras Asaf İnşaat
        </a>

        {/* Mobil Menü İkonu */}
        <div 
          className={isOpen ? 'navbar-burger open' : 'navbar-burger'} 
          onClick={toggleMenu}
        >
          <div className="burger-line1"></div>
          <div className="burger-line2"></div>
          <div className="burger-line3"></div>
        </div>

        {/* Menü Linkleri */}
        <ul className={isOpen ? 'navbar-menu active' : 'navbar-menu'}>
          {/* Anasayfa Linki - Özel Fonksiyonlu */}
          <li><a href="/" onClick={handleHomeClick}>Anasayfa</a></li>
          
          {/* Diğer Linkler - Sayfa İçi Kaydırma (#id ile) */}
          <li><a href="/#hakkimizda" onClick={closeMenu}>Hakkımızda</a></li>
          <li><a href="/#hizmetler" onClick={closeMenu}>Hizmetler</a></li>
          <li><a href="/#projeler" onClick={closeMenu}>Projelerimiz</a></li>
          <li><a href="/#iletisim" onClick={closeMenu}>İletişim</a></li>
          
          <li className="mobile-admin-link">
            <Link to="/login" onClick={closeMenu}>🔒 Admin Girişi</Link>
          </li>
        </ul>
        
        {/* Sağ Taraf */}
        <div className="navbar-right-side">
          <div className="navbar-contact">
            <a href="tel:05356828841">📞 0535 682 88 41</a>
          </div>
          <div className="navbar-admin-login">
            <Link to="/login" title="Admin Girişi">🔒</Link>
          </div>
        </div>

      </div>
    </nav>
  );
}

export default Navbar;